import factInteractions from './facts';

export default {
    __init__: ['factInteractions'],
    factInteractions: ['type', factInteractions]
};